'use client';

import dynamic from 'next/dynamic';

export const SoundExamplesFromBlog = dynamic(
  () => import('./SoundExamplesFromBlog')
);
export const UseSoundCheckboxDemo = dynamic(
  () => import('./CheckboxDemo')
);
export const UseSoundPopsDemo = dynamic(() => import('./PopsDemo'));
export const UseSoundGlugDemo = dynamic(() => import('./GlugDemo'));
export const UseSoundPlayPauseDemo = dynamic(
  () => import('./PlayPauseDemo')
);
export const UseSoundDrumMachineDemo = dynamic(
  () => import('./DrumMachineDemo')
);
